import { combineReducers } from 'redux';
import admin from '../screens/Admin/reducers/';
import user from '../screens/User/reducers/';
export default combineReducers({
  admin,
  user,
});



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/containers/App/screens/Tube/screens/CompanyRules/reducers/index.js
 **/